import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useParams, Link} from 'react-router-dom';
import PageBase from "../../../components/PageBase/index";
import Field from "../../../components/FieldGroup/Field/index";
import bullet from '../../../assets/title-bullet.png';
import * as marketingActions from "../../../redux/Marketing/actions";
import * as ROUTES from "../../../utils/routes";
import FieldGroup from "../../../components/FieldGroup/index";

import './EditMarketing.scss';
import ObjectSummaryRow from "../../../components/ObjectSummaryRow";

const EditMarketing = props => {
	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();
	const params = useParams();
	const marketing = useSelector(state => state.marketing.marketing?.find(mr => mr.Id === params.id));

	useEffect(() => {
		const load = async () => {
			if(marketing == null) {
				dispatch(marketingActions.loadMarketingById(params.id))
			}
		};
		load();
	}, [marketing, params.id]);

	if(marketing == null) {
		return <div/>;
	}

	const summary = [
		{ title: 'Marketing Activity', value: marketing.Name, blue: true},
		{ title: 'Status', value: marketing.Status__c},
		{ title: 'Next step', value: marketing.Next_step__c},
		{ title: 'Next step date', value: marketing.Next_step_date__c}
	];

	return (
		<PageBase title="Marketing"
		          removeMargins
		          bodyBg="#fff"
		          headerLinkText="All Marketings"
		          headerLinkTarget={ROUTES.MARKETINGS}
		>
			<div className="edit-marketing-title">
				<img src={bullet} style={{width: '24px', marginRight: '20px'}} />
				<span>{marketing.Name}</span>
			</div>

			<ObjectSummaryRow data={summary} />

			<div style={{height: '100%', overflowY: 'auto', padding: '0 20px'}}>
				<FieldGroup title="Details" expandable expanded>
					<Field title="Marketing Owner" highlight>{marketing.Owner?.Name}</Field>
					<Field title="Marketing Activity">{marketing.Name}</Field>

					<Field title="Account Name">{marketing.Account_Name__r?.Name}</Field>
					<Field title="Unique Identifier">{marketing.Unique_Identifier__c}</Field>

					<Field title="Event Date">{marketing.Event_date__c}</Field>
					<Field title="Status">{marketing.Status__c}</Field>

					<Field title="Category">{marketing.Category__c}</Field>
					<Field title="Event Type">{marketing.Event_Type__c}</Field>

					<Field title="Leading Cloud">{marketing.Leading_Cloud__c}</Field>
					<Field title="Description">{marketing.Description__c}</Field>

					<Field title="Related Funds">{marketing.Related_Funds__c}</Field>
					<Field title="Related Campaign">{marketing.Related_Campaign__c}</Field>
				</FieldGroup>

				<FieldGroup title="Activity" expandable>
					<Field title="Next Step">{marketing.Next_step__c}</Field>
					<Field title="Next Step Date">{marketing.Next_step_date__c}</Field>

					<Field title="Next Step POC">{marketing.Next_step_POC__r?.Name}</Field>
					<Field title="Next Step Owner">{marketing.Next_step_Owner__r?.Name}</Field>
				</FieldGroup>

				<FieldGroup title="System Information" expandable>
					<Field title="Created By">{marketing.CreatedBy.Name}</Field>
					<Field title="Last Modified By">{marketing.LastModifiedBy.Name}</Field>
				</FieldGroup>
			</div>
		</PageBase>
	)
};

export default EditMarketing;
